<template>
  <div class="ft-editor-form">
    <v-tabs
      v-model="selectedTab"
      :height="0"
      :hide-slider="true"
      class="ft-notabs ft-editor-form-tabs"
      @input="setSelectedPanel($event)"
    >
      <v-tab
        v-if="audit && audit.recordType && audit.id"
        :key="auditPanelId"
        :href="'#' + auditPanelId"
      >
        {{ auditPanelId }}
      </v-tab>
      <v-tab
        :key="editPanelId"
        :href="'#' + editPanelId"
      >
        {{ auditPanelId }}
      </v-tab>
    </v-tabs>

    <v-tabs-items
      v-model="selectedTab"
      :touchless="true"
    >
      <v-tab-item
        v-if="audit && audit.recordType && audit.id"
        :id="auditPanelId"
      >
        <audit-trail
          :id="audit.id"
          :key="audit.id"
          :record-type="audit.recordType"
          :created="audit.created"
          :updated="audit.updated"
          :name-not-found="auditNameNotFound"
          :load-name="auditName"
        />
      </v-tab-item>
      <v-tab-item :id="editPanelId">
        <v-form
          ref="editForm"
          v-model="formReady"
          :lazy-validation="true"
          class="pt-2"
        >
          <!-- Something strange about how the form/tab positions? -->

          <slot />

          <item-editor-buttons
            v-if="buttons"
            :is-new="buttons.isNew"
            :delete-action="buttons.deleteAction"
            :save-action="buttons.saveAction"
            :save-text="buttons.saveText"
            :save-icon="buttons.saveIcon"
            :save-color="buttons.saveColor"
            :delete-text="buttons.deleteText"
            :delete-icon="buttons.deleteIcon"
            :delete-color="buttons.deleteColor"
            :type="buttons.type"
            :loading="buttons.loading"
            :disabled="buttons.disabled"
            :delete-disabled="buttons.deleteDisabled"
            :save-disabled="buttons.saveDisabled"
          >
            <slot name="editor-buttons" />
          </item-editor-buttons>
        </v-form>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>

import AuditTrail from './AuditTrail'

export default {
  name: 'ItemEditorForm',
  components: {AuditTrail},
  props: {
    auditPanelId: String,
    editPanelId: String,
    auditNameNotFound: Function,
    auditName: Function,
    value: String,
    audit: Object,
    buttons: Object,
    errors: Array // Deprecated
  },

  data: function () {
    return {
      formReady: false,
      selectedTab: null
    }
  },
  watch: {
    value (val) {
      this.selectedTab = val
    },
    selectedTab (val) {
      this.$emit('input', val)
    }
  },
  mounted () {
    this.selectedTab = this.value
  },

  methods: {
    setSelectedPanel (val) {
      this.$emit('input', val)
    },
    validate () {
      const errors = this.$refs.editForm.inputs.filter(input => !input._isDestroyed && !input.validate(true)).length
      return errors < 1 // this.$refs.editForm.validate()
    }
  }

}
</script>
<style>
  .ft-error-snackbar .snack__content {
    padding-right: 0px;
  }
  .ft-notabs > .tabs__bar {
    display: none;
  }
</style>

